import React, { useMemo, useState, useRef } from "react";
import { motion } from "framer-motion";
import SearchSelect from "../SearchSelect";
import { CloseIcon, PlusIcon } from "../icons";
import { industries, months } from "../countries";
import * as Yup from "yup";

export default function StepTwo(props) {
  const { onInputChange, data, onAddHobby, onRemoveHobby } = props;
  props.stepRef.validateData = validateData;
  props.stepRef.focusBirthday = focusBirthday;
  const [typedHobby, setTypedHobby] = useState("");
  const [errors, setErrors] = useState([]);
  const mappedIndustries = useMemo(() => {
    const mapped = industries.map((ctr) => ({
      label: ctr,
      value: ctr,
      labelformated: ctr,
    }));
    return mapped;
  }, []);
  const mappedMonths = useMemo(() => {
    const mapped = months.map((ctr) => ({
      label: ctr.name,
      value: ctr.name,
      labelformated: ctr.name,
    }));
    return mapped;
  }, []);
  function handleSelectIndustry(val) {
    handleFormInput("industry", val.label);
  }
  function handleSelectMonth(val) {
    onInputChange("birthMonth", val.label);
  }

  const stepOneSchema = {
    industry: Yup.string().required().label("Industry"),
  };
  const schema = Yup.object().shape(stepOneSchema);
  async function validateData() {
    const stepOneData = {
      industry: data.industry,
    };
    try {
      await schema.validate(stepOneData, {
        abortEarly: false,
      });
      return { ok: true };
    } catch (error) {
      const errorObject = {};
      error.inner.forEach((e) => {
        errorObject[e.path] = e.message;
      });
      setErrors(errorObject);
      return { ok: false };
    }
  }
  function handleClearError(property) {
    setErrors({ ...errors, [property]: "" });
  }
  function handleFormInput(label, value) {
    handleClearError(label);
    onInputChange(label, value);
  }
  function handleAddHobby() {
    onAddHobby(typedHobby);
    setTypedHobby("");
  }

  const industrySearchSelect = useRef(null);
  const birthdayMonthSearchSelect = useRef(null);
  function focusBirthday() {
    birthdayMonthSearchSelect.focusSearch();
  }
  const hobbyText = useMemo(() => {
    const hbis = data.hobbies.length;
    if (hbis === 0) {
      return {
        text: "3 Max",
        btn: true,
      };
    }
    if (hbis === 1) {
      return {
        text: "2 left",
        btn: true,
      };
    }
    if (hbis === 2) {
      return {
        text: "1 left",
        btn: true,
      };
    }
    if (hbis === 3) {
      return {
        text: "Maxed out on hobbies!",
        btn: false,
      };
    }
  }, [data.hobbies]);
  function handleTypedHobby(e) {
    if (e.target.value.length > 50) return;
    setTypedHobby(e.target.value);
  }
  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
      <div className="mb-5">
        <label
          htmlFor="firstname"
          className="font-semibold mb-1 text-theme block"
        >
          Hobbies({hobbyText.text})
        </label>
        <div className="w-full  svelte-1l8159u">
          <div className="my-2 bg-opacity-0 bg-black p-1 flex border border-gray-200 rounded svelte-1l8159u">
            <div className="flex flex-auto flex-wrap"></div>

            <input
              autoComplete="new-input"
              type="text"
              value={typedHobby}
              onChange={handleTypedHobby}
              placeholder="Type hobby then click add..."
              // value={value}
              className="utilInputPlaceholder p-1 px-2 appearance-none outline-none w-full text-theme  svelte-1l8159u bg-opacity-0 bg-black "
            />
            <div className="text-theme w-20 py-1 pl-2 pr-1 border-l flex items-center border-gray-200 svelte-1l8159u">
              {hobbyText.btn && (
                <button
                  onClick={handleAddHobby}
                  className="bg-theme rounded-md text-white flex items-center px-2"
                >
                  <span className="mr-2">Add</span>
                  <PlusIcon iconClasses="h-3 w-3 fill-current" />
                </button>
              )}
            </div>
          </div>
        </div>
        <div className="flex flex-wrap">
          {data.hobbies.map((item, i) => (
            <div
              onClick={() => onRemoveHobby(item)}
              key={i}
              className="cursor-pointer flex items-center mr-2 my-1 px-4 py-1 rounded-xl text-theme bg-gray-100"
            >
              {item}
              <CloseIcon />
            </div>
          ))}
        </div>
      </div>
      <div className="mb-5">
        <label
          htmlFor="firstname"
          className="font-semibold mb-1 text-theme block"
        >
          Industry
        </label>
        <SearchSelect
          listOfValues={mappedIndustries}
          setSelectedValue={handleSelectIndustry}
          placeholder="Please select your area of expertise"
          defaultValue={data.industry ? data.industry : ""}
          searchSelectRef={industrySearchSelect}
        />
        {errors.industry ? (
          <small className="px-2 text-red-500 text-xs">{errors.industry}</small>
        ) : null}
      </div>
      <div className="mb-5">
        <label
          htmlFor="birthday"
          className="font-semibold mb-1 text-theme block"
        >
          Birthday (
          <span className="italic">We like celebrating all our members!!</span>)
        </label>
        <SearchSelect
          listOfValues={mappedMonths}
          setSelectedValue={handleSelectMonth}
          placeholder="Please choose month of birth"
          searchSelectRef={birthdayMonthSearchSelect}
          defaultValue={data.birthMonth ? data.birthMonth : ""}
        />
        <input
          type="number"
          value={data.birthDay}
          onChange={(e) => onInputChange("birthDay", e.target.value)}
          className="border-gray-200 border rounded py-2 px-2 appearance-none outline-none w-full text-theme  svelte-1l8159u bg-opacity-0 bg-black "
          placeholder="Enter your birth date..."
        />
      </div>
    </motion.div>
  );
}
